import { FormattedMessage } from '@flipster/i18n';
import { Styles, css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import { Picture, PictureProps } from '../../utils/Picture';

export const SparkRewardMultiply = ({
  css: cssProp,
  multiplyPicture,
}: {
  css?: Styles;
  multiplyPicture: PictureProps;
}) => {
  return (
    <section className={css({ textAlign: 'center' }, cssProp)}>
      <h2 className={css({ textStyle: 'Display/XL', color: 'content.default.level-5', mb: [20, 60] })}>
        How to gain more <br className={css({ display: ['initial', 'none'] })} />
        sparks
      </h2>
      <div className={vstack({ bg: 'background.default.level-0', rounded: 12, pt: 16 })}>
        <div
          className={css({
            mb: [12, 16],
            py: 4,
            px: 16,
            rounded: [40],
            textStyle: 'Text/L/Strong',
            color: 'content.default.level-5',
            bg: 'gray.300',
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_Rule' />
        </div>

        <h3 className={css({ textStyle: 'Title/M', color: 'content.default.level-5', mb: 40 })}>
          Multiply your sparks <br className={css({ display: ['initial', 'initial'] })} />
          based on your USDT <br className={css({ display: ['initial', 'none'] })} />
          balance!
        </h3>

        <Picture
          className={css({
            width: '100%',
            '& > img': {
              display: 'block',
              width: '100%',
              height: 'auto',
            },
          })}
          {...multiplyPicture}
        />
      </div>
    </section>
  );
};
